/**
 * Cennik AI — jeden globalny dokument dla wszystkich organizacji.
 *
 * Trzyma REALNE stawki dostawców (bez marży), a marża jest osobno. Rozdzielenie
 * jest celowe: po zmianie cennika OpenAI od razu widać, ile z kwoty jest kosztem,
 * a ile naszym narzutem.
 */

/** Ceny modelu rozmów live, USD za 1M tokenów. */
export interface RealtimeModelPrices {
  textIn: number;
  textCached: number;
  textOut: number;
  audioIn: number;
  audioCached: number;
  audioOut: number;
}

export const REALTIME_PRICE_FIELDS: { key: keyof RealtimeModelPrices; label: string }[] = [
  { key: 'textIn', label: 'Tekst wejście' },
  { key: 'textCached', label: 'Tekst z cache' },
  { key: 'textOut', label: 'Tekst wyjście' },
  { key: 'audioIn', label: 'Audio wejście' },
  { key: 'audioCached', label: 'Audio z cache' },
  { key: 'audioOut', label: 'Audio wyjście' },
];

/** Ceny modelu tekstowego, USD za 1M tokenów. */
export interface ChatModelPrices {
  input: number;
  output: number;
}

export interface PerMinutePrices {
  usdPerMin: number;
}

export interface AiMargins {
  chat: number;
  tts: number;
  stt: number;
  realtime: number;
}

export interface AiPrices {
  realtime: Record<string, RealtimeModelPrices>;
  chat: Record<string, ChatModelPrices>;
  tts: Record<string, PerMinutePrices>;
  stt: Record<string, PerMinutePrices>;
  elevenlabs: { usdPerChar: number };
  margins: AiMargins;
}

export interface AiPricesResponse extends AiPrices {
  /** `false` = cennik nie został jeszcze zapisany, widok pokazuje stan domyślny. */
  configured: boolean;
  updatedAt: number | null;
  updatedBy: string;
}

export const MARGIN_LABELS: Record<keyof AiMargins, string> = {
  chat: 'Wiadomości tekstowe',
  tts: 'Synteza mowy',
  stt: 'Transkrypcja',
  realtime: 'Rozmowy live (wartość domyślna)',
};
